import { lowerCase, upperFirst } from 'lodash-es';

const formatSnakeCaseTypeToLabel = (type: string): string =>
  upperFirst(lowerCase(type));

export default formatSnakeCaseTypeToLabel;
